// Colors embedded in Sales-Summary-Metrics.pdf (8-bit sRGB).
export const SALES_STATUS_COLORS = {
  new: { color: "#14B8A6", activeBackground: "#E6F7F5" },
  contacted: { color: "#0284C7", activeBackground: "#E0F2FE" },
  discovery: { color: "#E5A11A", activeBackground: "#FFF4D6" },
  proposal: { color: "#C026D3", activeBackground: "#FBE8FC" },
  client: { color: "#059669", activeBackground: "#E6F6EF" },
  lost: { color: "#E11D48", activeBackground: "#FDE8ED" },
  "do not contact": { color: "#64748B", activeBackground: "#F1F5F9" },
};

export const SALES_STATUS_DISABLED = { border: "#D2D8DE", color: "#A2ABB4" };

export function getSalesStatusColors(status) {
  const key = String(status || "").trim().toLowerCase();
  return SALES_STATUS_COLORS[key === "new lead" ? "new" : key === "clients" ? "client" : key];
}

export function getSalesStatusChipSx(status) {
  const palette = getSalesStatusColors(status);
  return palette
    ? { backgroundColor: palette.activeBackground, color: palette.color }
    : { backgroundColor: "#F3F4F6", color: "#4B5563" };
}
